module.exports = "/assets/data/9a71187b28390050effeb28138853856-LE10.data.json";